import axios from "axios";

/**
 * @description Get user profile from API /api/auth/profile
 * 
 * @param {Function} callbackFunction 
 * @returns {void}
 */
function APIGetProfileData( callbackFunction ) {
    let hostname = window.location.hostname;
    let protocol = window.location.protocol;
    let api_url = protocol + "//api." + hostname + "/api/auth/profile";
    
    // Check if User Logged In
    if(  window.UserProfile.is_logged_in == undefined || window.UserProfile.is_logged_in == false ) {
        return;
    };

    axios.post(
        api_url,
        null,
        {
            withCredentials: true
        }
    )
    .then( response => {
        var status = response.data.status;

        if( status == 1 && response.data.data !== undefined ) {

            var data = response.data.data;

            if( data.email ) {
                window.UserProfile.email = data.email;
            }

            if( data.first_name ) {
                window.UserProfile.first_name = data.first_name;
            }

            if( data.last_name ) {
                window.UserProfile.last_name = data.last_name;
            }

            if( data.username ) {
                window.UserProfile.username = data.username;
            }

            if( data.occupation ) {
                window.UserProfile.occupation = data.occupation;
            }

            if( data.state_id ) {
                window.UserProfile.state_id = data.state_id;
            }

            if( data.type ) {
                window.UserProfile.type = data.type;
            }            
            

            // Run Callback Function
            if ( 'function' == typeof callbackFunction ) {
                callbackFunction();
            }
        }
    } )
    .catch( ( error ) => {
        console.log( error )
    } );
}

export { APIGetProfileData };
